import styled from 'styled-components';
import { Transfer, Tree } from 'antd';

export const TablesTransfer = styled(Transfer)`
  max-height: 770px;
`;

export const TablesTree = styled(Tree)``;
